import dateIcon from '../../assets/icons/date-icon.png';

const DateTypeIcon = () => <img src={dateIcon} width='26' height='25' />;

export default DateTypeIcon;
